module.exports = require("./ar-EG.d.ts");